import { ApiResponse } from "../../utils/RequestBuilder";
import { orderApi } from "../api/OrderApi";
import { OrderModel } from "../models/order/OrderModel";
import {
  TypeDiscountEnum,
  TypePaymentMethodEnum,
} from "../models/order/PaymentModel";

class OrderManager {
  private static instance: OrderManager;

  public static get(): OrderManager {
    if (!this.instance) {
      this.instance = new OrderManager();
    }
    return this.instance;
  }

  async getOrCreateManager(
    moduleId: string
  ): Promise<ApiResponse<OrderModel> | undefined> {
    const result = await orderApi.getOrCreateOrder.requestHard({
      moduleId,
    });
    return result;
  }

  async assignCustomer({
    orderId,
    customerId,
  }: {
    orderId: string;
    customerId: string;
  }): Promise<boolean | undefined> {
    const result = await orderApi.assignCustomer.request({
      orderId,
      customerId,
    });
    return result.isSuccess;
  }

  async addItem({
    orderId,
    productId,
    quantity,
    moduleId,
    comments,
  }: {
    orderId: string;
    productId: string;
    quantity: number;
    moduleId: string;
    comments: string;
  }): Promise<boolean | undefined> {
    const result = await orderApi.addItem.request({
      orderId,
      productId,
      quantity,
      moduleId,
      comments,
    });
    return result.isSuccess;
  }

  async deleteItem({
    itemId,
    notes,
  }: {
    itemId: string;
    notes: string;
  }): Promise<boolean | undefined> {
    const result = await orderApi.deleteItem.request({
      itemId,
      notes,
    });
    return result.isSuccess;
  }

  async sendToPreparation({
    orderId,
  }: {
    orderId: string;
  }): Promise<boolean | undefined> {
    const result = await orderApi.sendToPreparation.request({
      orderId,
    });
    return result.isSuccess;
  }

  async doneStationOrder({
    stationOrderId,
  }: {
    stationOrderId: string;
  }): Promise<boolean | undefined> {
    const result = await orderApi.doneStationOrder.request({
      stationOrderId,
    });
    return result.isSuccess;
  }

  async payOrder({
    orderId,
    cashId,
    paymentMethod,
    moduleId,
    discountType,
    discountValue,
  }: {
    orderId: string;
    cashId: string;
    paymentMethod: TypePaymentMethodEnum;
    moduleId: string;
    discountType: TypeDiscountEnum;
    discountValue: number;
  }): Promise<OrderModel | undefined> {
    const result = await orderApi.payOrder.request({
      orderId,
      cashId,
      paymentMethod,
      moduleId,
      discountType,
      discountValue,
    });
    return result.data;
  }

  async getAllOrdersByDate({
    from,
    to,
  }: {
    from: string;
    to: string;
  }): Promise<OrderModel[] | undefined> {
    const result = await orderApi.getAllOrdersByDate.request({
      from,
      to,
    });
    if (!result.isSuccess) {
      throw new Error("Error on getAllOrdersByDate");
    }
    return result.data!;
  }
}

export const orderManager = OrderManager.get();
